import type {QueryFormulaEntry} from 'common/query-builder/query-entry-section/types';

const DefaultFormulaNamePrefix = `Formula`;

export function getNextFormulaName({existingFormulaNames}: {existingFormulaNames: string[]}): string {
  const getFormulaNumber = () => {
    const defaultFormulaNameRegex = RegExp(`^${DefaultFormulaNamePrefix} (\\d+)$`);
    const existingFormulaNumbers = existingFormulaNames
      .map((name) => name.match(defaultFormulaNameRegex)?.[1])
      .filter((numStr) => numStr)
      .map((numStr) => Number(numStr));
    return Math.max(existingFormulaNames.length, ...existingFormulaNumbers) + 1;
  };

  return existingFormulaNames.length === 0
    ? DefaultFormulaNamePrefix
    : `${DefaultFormulaNamePrefix} ${getFormulaNumber()}`;
}

export function getFormulaEntryTrackingProps(entry: QueryFormulaEntry) {
  const operatorsCount = (entry.event.value.match(/\*|\/|\+|-/g) || []).length;
  const operandsCount = (entry.event.value.match(/[A-Z]+/g) || []).length;
  return {
    name: entry.event.label,
    definition: entry.event.value,
    operandsCount,
    operatorsCount,
  };
}
